import React, { useState, useEffect, useCallback } from 'react'
import * as components from '../../components'
import {useDispatch, useSelector} from 'react-redux'
import { TokensDataGrid } from './TokensDataGrid'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'

export const TokenListPage = (props) => {
  const dispatch = useDispatch()
  const [getAPIResults, setGetAPIResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState(null)
  const [gridData, setGridData] = useState({})
  const [hiddenRowKeys, setHiddenRowKeys] = useState([])
  const { user,is_superuser } = useSelector((state) => state.auth)
  const canViewContactDetails = (user.role === 'SuperUser' || is_superuser || user.role==="Privileged")
  const handleTableChange = (type, { page, sizePerPage }) => {
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }

  const getData = useCallback(
    (data) => {
      let finalPayload = { ...gridData, ...data }
      setGetAPIResult(null)
      setLoading(true)
      new rest.TokenService()
        .makeGetRequestForAll(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
          setLoading(false)
        })
        .catch((errors) => {
          setLoading(false)
          dispatch(
            showErrorToast(
              'Could Not Load Tokens  Data.',
              JSON.stringify(errors)
            )
          )
        })
    },
    [dispatch, gridData]
  )
  useEffect(() => {
    getData()
  }, [getData, dispatch])
  return loading ? (
    <components.Loading />
  ) : (
    <>
      {errors ? <components.ErrorDisplay error={errors} /> : ''}
      {!errors && getAPIResults ? (
        <TokensDataGrid
          onTableChange={handleTableChange}
          onFilter={onFilter}
          getData={getData}
          hiddenRowKeys={hiddenRowKeys}
          results={getAPIResults.results}
          pageSize={getAPIResults.page_size}
          count={getAPIResults.count}
          current={getAPIResults.current}
          onError={setErrors}
          onDelete={(item) => {
            setHiddenRowKeys([...hiddenRowKeys, item.url])
          }}
          canViewContactDetails={canViewContactDetails}
        />
      ) : (
        ''
      )}
    </>
  )
}
